//==============================================
// Navigation: Sub Menu
//==============================================


// Menu open Function
export function menuOpen(target){
   let subElementsHeight = 0,
       subElementsWidth = 0,
       menuItemPosCurrent = target.children('.menu-item-link').position(),
       menuItemWidthCurrent = target.children('.menu-item-link').width(),
       menuSubMenuCurrent = target.children('.menu__sub-menu');

   // Get Width and Height for Menu
   menuSubMenuCurrent.children().each(function(){

       // Total Height
       subElementsHeight = subElementsHeight + $(this).outerHeight(true);

       // Biggest Width
       subElementsWidth = ($(this).outerWidth(true) > subElementsWidth )? $(this).outerWidth(true) : subElementsWidth; 
   });
   
   
   // Set Width
   if(target.is(':last-of-type')){

        // If is last of type
       menuSubMenuCurrent.css({
           'width': subElementsWidth, 
           'left': menuItemPosCurrent.left - (subElementsWidth - menuItemWidthCurrent) + 12,
           'transition-delay': '0.25s'
       });

   }else{

        // If normal
       menuSubMenuCurrent.css({
           'width': subElementsWidth, 
           'left': menuItemPosCurrent.left - 12,
           'transition-delay': '0.25s'
       });
   }
   
   // Set Height
   menuSubMenuCurrent.css('height', subElementsHeight);
}

// ========== Click: Sub Menu Dropdown ==========

export let subMenu = () => {

    
    let subMenuItem = $('.menu-item--has-children'),
        menuSubMenu = $('.menu__sub-menu');

    // Setup aria attributes for submenu	
    subMenuItem.attr({
        'aria-haspopup': 'true',
        'aria-expanded': 'false'
    });

    // ========== Interaction: Click -menu Item ==========
    subMenuItem.on('click keypress', function(){

        //e.preventDefault();

        let targetClick = $(this);

        // Rest all
        menuSubMenu.css('height', 0);
        targetClick.attr('aria-expanded', 'false');
        
        
        if (targetClick.attr('aria-expanded') === 'false') {
            
            // Set Height
            targetClick.attr('aria-expanded', 'true');
            menuOpen(targetClick);
            
        }else{
            // Height rest
            targetClick.attr('aria-expanded', 'false');
            menuSubMenu.css('height', 0);
        }

    });

};